import { transformTableQueryForKy } from "../../helpers/tableHelpers";
import {
  ServiceObjectTableQuery,
  ServiceObjectUpcomingRevisionsTableQuery,
} from "../../pages/serviceObjects/models";
import { privateGet } from "../clients/createPrivateClient";
import {
  CPServiceObjectDetail,
  TableResultCPServiceObject,
  TableResultCPUpcomingServiceObjectRevision,
} from "../models/unified";

export default {
  getServiceObjects: async (query: ServiceObjectTableQuery) => {
    const result = await privateGet<TableResultCPServiceObject>(
      "customerPortal/serviceObject/v2",
      {
        ...transformTableQueryForKy(query),
      },
    );

    return result;
  },
  getUpcomingRevisions: async (
    query: ServiceObjectUpcomingRevisionsTableQuery,
  ) => {
    const result = await privateGet<TableResultCPUpcomingServiceObjectRevision>(
      "customerPortal/serviceObject/v2/upcoming-revisions",
      {
        ...transformTableQueryForKy(query),
      },
    );

    return result;
  },
  getServiceObjectDetail: async (id: string) => {
    const result = await privateGet<CPServiceObjectDetail>(
      `customerPortal/serviceObject/v2/${id}`,
    );

    return result;
  },
};
